
.RowCell {
  white-space: pre-wrap;
  word-break: break-word;
}
